import { memoize } from 'proxy-memoize'

export const userSelector = (state) => state.user;

export const tokenSelector = memoize((state) => state?.user?.user?.token);